import { FIFTEEN_DAYS } from '../constants';
export const isEnvelopeExpired = (timestamp: number): boolean => Date.now() - timestamp > FIFTEEN_DAYS;
